<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
  >
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="accent"
    ></v-progress-linear>

    <v-toolbar-title style="width: 300px" class="ml-0 pl-0 pl-md-4">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" />
      <span class="hidden-sm-and-down">{{
        currentUser ? currentUser.company : "NEXUS"
      }}</span>
 
    </v-toolbar-title>
    <v-spacer />

    <v-card class="d-inline-flex pa-2" min-width="200px" flat color="transparent">
      <v-select
        :items="centerList"
        v-model="selectedCenter"
        menu-props="auto"
        label="Location"
        hide-details
        return-object
        item-text="name"
        item-value="id"
        @change="changeCenter"
        prepend-icon="mdi-office-building-marker-outline"
      ></v-select>
    </v-card>
    <v-menu v-if="modules && modules.length > 0" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn tile large icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-grid</v-icon>
        </v-btn>
      </template>
      <v-card class="mx-auto" max-width="400" width="300" tile>
        <v-card-text>
        <v-row>
          <v-col v-for="module in modules" :key="module.id" style="text-align: center;" cols="6">
            <v-hover v-slot="{ hover }">
              <v-sheet @click="toApp(module)" :elevation="hover ? 16 : 0"
                  :class="{ 'on-hover': hover }">
              <v-icon size="50" :color="module.color"> {{module.icon}} </v-icon><br/>
              {{module.name}}
              </v-sheet>
            </v-hover>
          </v-col>
        </v-row>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-btn data-cy="login" to="/login" v-if="!isLoggedIn" icon title="Login">
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <div v-if="currentUser" class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-2" tile large icon v-bind="attrs" v-on="on">
            <v-icon>mdi-shield-account</v-icon>
          </v-btn>
        </template>

        <v-card class="mx-auto" max-width="400" width="200" tile>
          <v-list dense>
            <v-list-item-group v-model="menuItem" color="primary">
              <v-list-item disabled>
                <v-list-item-title>
                  {{ currentUser.firstName }} {{ currentUser.lastName }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                :to="item.link"
                v-for="(item, i) in userMenu"
                :key="i"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :to="{name: 'EditProfile'}">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-account-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit Profile</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { parseDomain } from "parse-domain";


export default {
  data: () => ({
    selectedCenter: null,
    centerList: [],
    drawer: null,
    menuItem: 1,
    userMenu: [
      // {
      //   text: "My Home",
      //   link: "/secure/myhome",
      //   icon: "mdi-account",
      // },
    ],
    modules: []
  }),
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),
  },
  async mounted(){
    //check jwt token all each page reload
    await this.remoteJwtTokenCheck();

    if(!this.currentUser)
      return;

    this.initCenters()
      .then( (centers) => {
        this.centerList = centers;
        if(this.centerList && this.centerList.length > 1){
          this.centerList.unshift({id: null, name: 'All Locations', accountId: this.centerList[0].accountId})
        }
        this.setMyCenters(centers);

        this.selectedCenter = this.globalCenter;
        if(centers && centers.length > 0){
          const existIndex = centers.findIndex(c => this.selectedCenter && c.id == this.selectedCenter.id);
          if(!existIndex || existIndex < 0){
            this.selectedCenter = centers[0];
            this.setCenter(this.selectedCenter);
          }
        }
      })
      .finally( () => {
        this.$emit('load', this.selectedCenter)
      })

    this.initModules()
      .then( (modules) => {
        if(modules){
          this.modules = modules.filter(m => m.path !== process.env.VUE_APP_MODULE)
        }
      })
  },
  methods: {
    ...mapActions("auth", ["processLogout", "setMyCenters", "remoteJwtTokenCheck"]),
    ...mapActions("navigation", ["toggleDrawer", "hideDrawer", "setCenter", "clearCenter"]),
    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.processLogout();
        this.clearCenter();
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({ name: "Login" });
      });
    },
    changeCenter(){ console.log("from the inside")
      this.setCenter(this.selectedCenter);
      console.log(this.selectedCenter)
      // this.$router.go();
      window.location.reload()
      console.log("inside 3")
    },
    async initCenters(){
      return await this.$axios.get('/center/get-my-centers')
        .then( (resp) => {
          const centers = resp.data;
          return centers;
        })
    },
    async initModules(){
      return await this.$axios.get('/user/module', { params: {user_id: this.currentUser.uId }})
        .then( (resp) => {
          return resp.data;
        })
    },
    toApp(app){
      if(process.env.NODE_ENV != 'development'){
        const parseResult = parseDomain(window.location.hostname);
        const { domain, topLevelDomains } = parseResult;
        const topLevel = topLevelDomains.join(".");

        const moduleUrl = `https://${app.path}.${domain}.${topLevel}`;
        window.location.href = moduleUrl;
      }
    }
  },
};
</script>

<style>
</style>